import { IAgentFormRow } from "components/agents-limit-reached";
import Role from "constants/role";
import { isEmail } from "helpers/validate";

export interface ISimpleAgentFormRow {
  email: string | null;
  permission: Role | null;
}

type FormRow = ISimpleAgentFormRow | IAgentFormRow;
type FormRows = FormRow[];

export function guessName(email: string): string {
  return email
    .replace(/@\S+/, "")
    .replace(/\+\S+/, "")
    .replace(/\./g, " ")
    .replace(/_/g, " ")
    .replace(/(?:^|\s)\S/g, a => a.toUpperCase());
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function addNameToAgent(agent: IAgentFormRow) {
  return agent.name ? agent : { ...agent, name: guessName(agent.email) };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function removeDuplicatedAndEmptyAgents(acc: IAgentFormRow[], agent: IAgentFormRow) {
  if (acc.some(a => a.email === agent.email) || !agent.email) {
    return acc;
  }
  return [...acc, agent];
}

export function normalizeAgentBatchPayload(agents: IAgentFormRow[]): IAgentFormRow[] {
  return agents.reduce(removeDuplicatedAndEmptyAgents, []).map(addNameToAgent);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const hasValidEmail = (agent: FormRow) => agent.email && isEmail(agent.email);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getNonViewersToAdd = (agents: FormRows) => getNonViewers(agents).filter(hasValidEmail).length;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const containsValidEmails = (agents: FormRows) => {
  return agents.some(hasValidEmail);
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getViewers = (agents: FormRows) => agents.filter(agent => agent.permission === Role.Viewer);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getNonViewers = (agents: FormRows) => agents.filter(agent => agent.permission !== Role.Viewer);
